import { connect } from "react-redux";
import React from "react";
import { RouteProps } from "react-router";
import { Grid, Paper } from "material-ui";
import { ReduxState, ReduxDispatch } from "../../../../ducks/reducers";

import ChatAvatar from "./ChatAvatar";
import ChatMessages from "./ChatMessages";
import { IChatMessage } from "../../../../util/interfaces";
import {
    SetHeader,
    ShowBackNavigationWithRoute,
    SetShowBackNavigation,
} from "../../../../ducks/common";
import ReplyInput from "./ReplyInput";
import { Link } from "react-router-dom";
import { sendMessage } from "../../../../ducks/messages";
import {
    CreateMessageDto,
    MessageSender,
    MessageStatus,
} from "../../../../util/DTOs/MessageDtos";

export interface IHandler {
    name: string;
    avatarUrl: string;
    avatarFileName: string;
}

/**
 * Props provided by redux
 */
interface IChatWrapperProps {
    messages: IChatMessage[];
    handler: IHandler;
    threadId: number;
    readOnlyThread: boolean;
}

/**
 * Dispatch functions provided by redux
 */
interface IChatWrapperDispatchProps {
    setHeader: (value: string) => void;
    setBackButton: (route: string) => void;
    hideBackButton: () => void;
    sendMessage: (threadId: number, body: string) => void;
}

/**
 * Internal state of this component
 */
interface IChatWrapperState {
    windowHeight: number;
}

interface IChatWrapperReduxProps {}

/**
 * Combined properties of he component
 */
type ChatWrapperProps = IChatWrapperProps &
    IChatWrapperDispatchProps &
    RouteProps;

class ChatWrapper extends React.Component<ChatWrapperProps, IChatWrapperState> {
    state = { windowHeight: window.innerHeight };

    componentDidMount() {
        this.props.setHeader("");
        this.props.setBackButton("/messages");
        window.addEventListener("resize", this.windowResize);
    }

    componentWillReceiveProps() {
        window.scrollTo(0, document.body.scrollHeight);
    }

    componentWillUnmount() {
        this.props.hideBackButton();
        this.props.setHeader("");
        window.removeEventListener("resize", this.windowResize);
    }

    windowResize = () => {
        this.setState((prevState) => ({
            ...prevState,
            windowHeight: this.calculateWindowHeight(),
        }));
    };

    calculateWindowHeight() {
        return window.innerHeight;
    }

    handleSending = (submit: boolean, body?: string) => {
        if (this.props.threadId && body && body.trim().length > 0) {
            this.props.sendMessage(this.props.threadId, body);
        }
    };

    render() {
        const { messages, handler } = this.props;
        // Subtract AppBar height and ReplyInput height from windowHeight
        const height = this.state.windowHeight - 50 - 109;

        return (
            <div>
                <Grid
                    container
                    spacing={
                        0
                    } /*style={{height: height, overflowY: "scroll"}}*/
                >
                    <Grid item xs={12}>
                        <Paper>
                            <ChatAvatar
                                name={handler.name}
                                image={handler.avatarUrl}
                            />
                        </Paper>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        style={{
                            paddingBottom: this.props.readOnlyThread ? 0 : 90,
                        }}
                    >
                        <ChatMessages messages={messages} />
                    </Grid>
                </Grid>
                {(!this.props.readOnlyThread && (
                    <Grid container spacing={0}>
                        <Grid
                            id="replyinput-grid"
                            item
                            xs={12}
                            style={{
                                position: "fixed",
                                width: "100%",
                                bottom: 0,
                            }}
                        >
                            <ReplyInput handleSending={this.handleSending} />
                        </Grid>
                    </Grid>
                )) || (
                    <Grid container spacing={0}>
                        <Grid
                            item
                            xs={12}
                            style={{ width: "100%", textAlign: "center" }}
                        >
                            <h3 className="hypodgrey">
                                Viestiketju on suljettu. Aloita halutessasi{" "}
                                <Link
                                    style={{
                                        textDecoration: "none",
                                        color: "#3a649e",
                                    }}
                                    to={"/messages/new-thread"}
                                >
                                    uusi viestiketju.
                                </Link>
                            </h3>
                        </Grid>
                    </Grid>
                )}
            </div>
        );
    }
}
const mapStateToProps = (state: ReduxState): IChatWrapperReduxProps => {
    return {};
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IChatWrapperDispatchProps => {
    return {
        setHeader: (value: string) => {
            dispatch(SetHeader(value));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
        sendMessage: (threadId: number, body: string) => {
            dispatch(
                sendMessage({
                    messageThreadId: threadId,
                    content: body,
                    status: MessageStatus.New,
                    sender: MessageSender.Customer,
                } as CreateMessageDto)
            );
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatWrapper);



// WEBPACK FOOTER //
// ./src/views/messages/threadpage/components/ChatWrapper.tsx